
<template>
    <div class="mask_module">
    <div class="pay_module">
       
        <img class="close_btn" @click="pay(0)" src="@/images/close_1.png" alt="">
        <div class="pay_title">{{payTitle}}</div>
        <div class="flex2" >
            
            <div class="pay_num">
                <div class="pay_m">￥</div>
                {{payMoney}}</div>
        </div>
        <div class="pay_btn" @click="pay(1)">确认支付</div>
    </div>
    </div>

</template>

<script>
import refusePic from "@/images/refuse_pic.png"
import refuseVid from "@/images/refuse_vid.png"
export default {
    props:["payTitle","payMoney"],

    data(){
        return {
          refusePic,
          refuseVid
        }
    },
    methods:{
        pay(type){
            this.$emit("pay",type)
        }
    }
}
</script>



<style lang="scss" scoped>
    .pay_module{
        width: 260px;
        padding: 50px 0 40px 0;
        text-align: center;
        // height: 230px;
        background-color: #fff;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        border-radius: 14px;
        .flex2{
            justify-content: center;
            
        }
        .pay_m{
            font-size: 20px;
            font-weight: bold;
            position: absolute;;
            left: -20px;
            top: 50%;
            transform: translateY(-50%);
        }
        .pay_num{
            font-size: 30px;
            font-weight: bold;
            position: relative;
        }
        .pay_title{
            font-size: 14px;
            margin-bottom: 8px;
        }
        .close_btn{
            font-size: 24px;
            color: #CCCCCC;
            position: absolute;
            top: 10px;
            left: 10px;
            width: 24px;
            height: 24px;
        }
        .pay_btn{
            background-color: rgba(44, 59, 140, 1);
            color: #fff;
            width: 50%;
            margin: 0 auto;

            border-radius: 20px;
            padding:8px 0 ;
            margin-top: 50px;
        }
    }
</style>
